import { createReducer, on } from '@ngrx/store';
import { Event, EventDefinition, EventProtocol, NotificableEvent } from '../../../shared/interfaces/event.interfaces';
import { EventActions } from './event.actions';

export const eventFeatureKey = 'event';

export interface EventState {
  eventsCount?: number | undefined;
  events?: Event[] | undefined;
  lastEventDate?: string | undefined;
  selectedEvent?: Event | undefined;
  eventDefinitions?: EventDefinition[] | undefined;
  selectedDefinition?: EventDefinition | undefined;
  notificableEvents?: NotificableEvent[] | undefined;
  eventProtocols?: EventProtocol[] | undefined;
  selectedProtocol?: EventProtocol | undefined
}

export const initialState: EventState = {
};

export const eventReducer = createReducer(
  initialState,

  on(EventActions.loadAllEventsSuccess, (state, action) => { return { ...state, eventsCount: action.data.count, events: action.data.events, lastEventDate: action.data.oldest } }),
  
  on(EventActions.loadAccountEventsSuccess, (state, action) => { return { ...state, eventsCount: action.data.count, events: action.data.events, lastEventDate: action.data.oldest } }),
  
  on(EventActions.loadEventByIdSuccess, (state, action) => { return { ...state, selectedEvent: action.data } }),

  on(EventActions.loadEventProtocolsSuccess, (state, action) => { return { ...state, eventProtocols: action.data }; }),

  on(EventActions.loadEventProtocolByIdSuccess, (state, action) => { return { ...state, selectedProtocol: action.data }; }),

  on(EventActions.loadEventDefinitionsSuccess, (state, action) => {
    const sortedDefinitions = [...action.data].sort((a, b) => a.name.localeCompare(b.name));
    return { ...state, eventDefinitions: sortedDefinitions };
  }),

  on(EventActions.loadEventDefinitionByIdSuccess, (state, action) => { return { ...state, selectedDefinition: action.data }; }),

  on(EventActions.filterNotificableEventsSuccess, (state, action) => { return { ...state, notificableEvents: action.data } }),
  on(EventActions.unsetNotificableEvents, (state) => { return { ...state, notificableEvents: undefined } }),

  on(EventActions.unsetEventStore, () => initialState)
);
